const indexes = {

  /**
   * 获得题目/选项索引
   * @param id
   * @returns {*}
   */
  getIndexe (id) {
    return this.indexes[id]
  },

  createAllIndexes () {
    this.indexes = {}
    this.questions.forEach((question, index) => {
      this.createIndexes(question, this.answers[index])
    })
    this.updateIndexeJumped()
  },

  createIndexes (question, answer) {
    // 题目 MAP
    this.indexes[question.id] = {
      type: 'question',
      index: () => this.questions.indexOf(question),
      element: null,
      source: this.questions,
      data: question,
      answer,
      isJumped: false
    }

    // 选项 MAP
    if (question.options) {
      question.options.forEach((option) => {
        this.indexes[question.id + option.id] = {
          type: 'option',
          index: () => question.options.indexOf(option),
          question: question,
          source: question.options,
          data: option
        }
      })
    }
  },

  /**
   * 更新索引跳转信息
   */
  updateIndexeJumped () {
    let jumpTargetId = null
    for (let index = 0; index < this.questions.length; index++) {
      let question = this.questions[index]
      let indexe = this.indexes[question.id]
      // 寻找跳转目标
      if (jumpTargetId) {
        // 未找到匹配的跳转目标
        if (jumpTargetId !== question.id || jumpTargetId === 'end') {
          // 被跳越的
          indexe.isJumped = true
          continue
        }
      }
      // 获得跳转目标 ID
      jumpTargetId = this.getJumpTargetId(question.id)
      indexe.isJumped = false
    }
  }
}

export default indexes



// WEBPACK FOOTER //
// ./src/views/question-review/review/indexes.js